// extracted by mini-css-extract-plugin
export default {"youtube-container":"youtube-container--i0lrD","youtubeContainer":"youtube-container--i0lrD","video-container":"video-container--ZO1m4","videoContainer":"video-container--ZO1m4"};